import React, { useState, useEffect } from 'react';
import axios from '../../../Data/Axios';
import '../Topik250725/index.scss';
import { useSession } from '@/Recoil/Session/Session';
import TopikImage from '@/Components/Product/TopikImage';

function Topik250622() {
    const productId = 'topik_II.250622.01';

    const [preferredWeekdays, setPreferredWeekdays] = useState<string[]>([]);
    const [countryCode, setCountryCode] = useState('+62');
    const [whatsappNumber, setWhatsappNumber] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [columnWidth, setColumnWidth] = useState(300);
    useEffect(() => {
        const handleResize = () => {
            const newWidth = Math.min(window.innerWidth, 800);
            setColumnWidth(newWidth);
        };

        handleResize(); // Set initial width
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    const {sessionRefresh} = useSession();

    const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const weekdayLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    const handleWeekdayChange = (day: string) => {
        setPreferredWeekdays(prev => 
            prev.includes(day) 
                ? prev.filter(d => d !== day)
                : [...prev, day]
        );
    };

    useEffect(() => {
        // Log product view behavior if you have analytics
        sessionRefresh();
        console.log('TOPIK 250622 product viewed');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (preferredWeekdays.length === 0 || !whatsappNumber) {
            alert('Please fill in all fields');
            return;
        }

        setIsSubmitting(true);
        try {
            const fullPhoneNumber = `${countryCode}${whatsappNumber}`;
            const currentDate = new Date().toLocaleString();
            
            // Create HTML email content
            const htmlContent = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>TOPIK 250622 Survey Submission</title>
                    <style>
                        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; margin: 0; padding: 20px; background-color: #f4f4f4; }
                        .container { max-width: 600px; margin: 0 auto; background: white; border-radius: 10px; overflow: hidden; box-shadow: 0 0 20px rgba(0,0,0,0.1); }
                        .header { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 30px; text-align: center; }
                        .content { padding: 30px; }
                        .info-table { width: 100%; border-collapse: collapse; margin: 20px 0; }
                        .info-table th, .info-table td { border: 1px solid #ddd; padding: 12px; text-align: left; }
                        .info-table th { background-color: #f8f9fa; font-weight: bold; }
                        .footer { background-color: #f8f9fa; padding: 20px; text-align: center; color: #666; font-size: 14px; }
                    </style>
                </head>
                <body>
                    <div class="container">
                        <div class="header">
                            <h1>🎯 TOPIK 250622 Survey Submission</h1>
                            <p>New participant registration</p>
                        </div>
                        <div class="content">
                            <h2>Survey Details</h2>
                            <table class="info-table">
                                <tr>
                                    <th>Field</th>
                                    <th>Response</th>
                                </tr>
                                <tr>
                                    <td><strong>Preferred Weekdays</strong></td>
                                    <td>${preferredWeekdays.join(', ')}</td>
                                </tr>
                                <tr>
                                    <td><strong>WhatsApp Number</strong></td>
                                    <td>${fullPhoneNumber}</td>
                                </tr>
                                <tr>
                                    <td><strong>Product ID</strong></td>
                                    <td>${productId}</td>
                                </tr>
                                <tr>
                                    <td><strong>Submission Date</strong></td>
                                    <td>${currentDate}</td>
                                </tr>
                            </table>
                            
                            <div style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 8px; padding: 15px; margin: 20px 0;">
                                <p><strong>⚠️ Action Required:</strong> Session consists of 10 people on a first-come-first-served basis. Please process this registration and send session details + payment link when ready.</p>
                            </div>
                        </div>
                        <div class="footer">
                            <p>This email was generated automatically from the TOPIK 250622 product page.</p>
                            <p>Korean Mate • <a href="https://koreanmate.app">koreanmate.app</a></p>
                        </div>
                    </div>
                </body>
                </html>
            `;

            // Send email to dl_mate
            const response = await axios.post('/admin/trigger-email', {
                email: 'dl_mate@webtoon.today',
                subject: `[🎯TOPIK II] Class survey`,
                body: htmlContent,
                groups: 'dl_mate@webtoon.today'
            });

            if (response.data && response.data.code === 200) {
                alert('Survey submitted successfully! We will contact you when the session is ready.');
                setPreferredWeekdays([]);
                setCountryCode('+62');
                setWhatsappNumber('');
                setIsSubmitted(true);
            } else {
                throw new Error('Email sending failed');
            }
        } catch (error) {
            console.error('Error submitting survey:', error);
            alert('Error submitting survey. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="topik-250725-page">
            <div className="topik-content">
                <div className="topik-detail-page">
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250622/MATE_TOPIK2_class_001.png'}
                        alt={`TOPIK 250622 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250622/MATE_TOPIK2_class_002.png'}
                        alt={`TOPIK 250622 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <div className="video-container">
                        <iframe
                            width={columnWidth} height={columnWidth / 560 * 315}
                            src="https://www.youtube.com/embed/R8p177f-1YU?si=JYLkamue7pK9vN27"
                            title="YouTube video player" frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                        />
                    </div>
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250622/MATE_TOPIK2_class_003.png'}
                        alt={`TOPIK 250622 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250622/MATE_TOPIK2_class_004.png'}
                        alt={`TOPIK 250622 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250622/MATE_TOPIK2_class_005.png'}
                        alt={`TOPIK 250622 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250622/MATE_TOPIK2_class_006.png'}
                        alt={`TOPIK 250622 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250622/MATE_TOPIK2_class_007.png'}
                        alt={`TOPIK 250622 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250622/MATE_TOPIK2_class_008.png'}
                        alt={`TOPIK 250622 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250622/MATE_TOPIK2_class_008.5.png'}
                        alt={`TOPIK 250622 Detail Page 001`}
                        className="detail-page-slice"
                    />
                    <TopikImage
                        src={'https://static.koreanmate.app/product/topik-250622/MATE_TOPIK2_class_009.png'}
                        alt={`TOPIK 250622 Detail Page 001`}
                        className="detail-page-slice"
                    />
                </div>

                <div id={"CTA"} className="survey-section">
                    <form onSubmit={handleSubmit} className="topik-survey-form">
                        <h3>Join TOPIK Session</h3>
                        
                        <div className="form-group">
                            <label>Preferred Weekdays</label>
                            <div className="button-group">
                                {weekdays.map((day, index) => (
                                    <button
                                        key={day}
                                        type="button"
                                        className={`weekday-button ${preferredWeekdays.includes(day) ? 'selected' : ''} ${day === 'Saturday' || day === 'Sunday' ? 'weekend' : ''}`}
                                        onClick={() => handleWeekdayChange(day)}
                                    >
                                        {weekdayLabels[index]}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="whatsapp">{"My WhatsApp Number"}</label>
                            <div className="phone-input">
                                <input
                                    type="text"
                                    className="country-code-input"
                                    value={countryCode}
                                    onChange={(e) => setCountryCode(e.target.value)}
                                    placeholder="+62"
                                />
                                <input
                                    type="tel"
                                    id="whatsapp"
                                    value={whatsappNumber}
                                    onChange={(e) => setWhatsappNumber(e.target.value)}
                                    placeholder="8000000000000"
                                    required
                                />
                            </div>
                        </div>

                        <button type="submit" disabled={isSubmitting || isSubmitted} className="submit-button">
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>

                        <div className="warning-message">
                            <p>
                                <strong>{"⚠️ Penting:"}</strong>{" Sesi terdiri dari 10 orang dengan sistem first come first served, dan jika sesi sudah terpenuhi, detail sesi dan link pembayaran akan dikirimkan kepada Anda."}
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Topik250622;